import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';

import {
    Table,
    Space,
    Tooltip
} from 'antd';
import { Tag } from '../../Reusable/Text';
import TableView from '../../Reusable/TableView';
import { Flex } from '../../Reusable/Container';
import { TextButton } from '../../Reusable/Button';
import AlertModal from '../../Reusable/AlertModal'
import { ErrorAlert } from '../../Reusable/Alert'
import { apiPOSTReq } from '../../../Utils/api'
import environment from '../../../environment'
import Lock from '../../../Images/lock-locked.svg'
import Unlock from '../../../Images/hya-lock.png'


class AccountsTable extends Component {
    state = {
    };

    selectRow = (record) => {
        this.props.showSelectedAccount(record);
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.props.fetchBBAccounts({ pagination: pagination, sorter: sorter });
    }

    showAccountRestrictions = (selectedAccount) => {
        this.props.history.push({
            pathname: '/support/bb-acc/restrictions',
            state: { account: selectedAccount }
        })
    }

    lockAccount = (account) => {
        const { pagination, sorter } = this.props;
        const body = {
            accountNumber: account?.accountNumber,
        }

        apiPOSTReq(`${environment.bbBaseUrl}/bb/lockAccount`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    console.log(`lockAccount resp`, data)
                    this.props.fetchBBAccounts({ pagination: pagination, sorter: sorter });
                    this.setState({ showLockAccount: false, accountToLock: null, lockLoading: false })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log(`lockAccount resp`, error)
                ErrorAlert({ description: error.message })
            }
        })
    }

    unlockAccount = (account) => {
        const { pagination, sorter } = this.props;
        const body = {
            accountNumber: account?.accountNumber,
        }

        apiPOSTReq(`${environment.bbBaseUrl}/bb/unlockAccount`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    console.log(`unlockAccount resp`, data)
                    this.props.fetchBBAccounts({ pagination: pagination, sorter: sorter });
                    this.setState({ showUnlockAccount: false, accountToUnlock: null, unlockLoading: false })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log(`unlockAccount resp`, error)
                ErrorAlert({ description: error.message })
            }
        })
    }

    render() {
        const { showLockAccount, lockLoading, accountToLock, showUnlockAccount, unlockLoading, accountToUnlock } = this.state;
        const { theme, aionStore, loading, pagination, bbAccounts } = this.props;
        const StatusTag = (options) => {
            let { account } = options;
            const { status } = account;
            return (
                <Space wrap>
                    {status && <Tooltip title="Status"><Tag tagpreset={theme.colors.secondary7}>{account?.locked === true ? "LOCKED" : status?.toUpperCase()}</Tag></Tooltip>}
                </Space>
            )
        }
        const columns = [
            {
                title: 'Nickname',
                dataIndex: 'nickName',
                key: 'nickName',

            },
            {
                title: 'Account Number',
                dataIndex: 'accountNumber',
                key: 'accountNumber',
            },
            {
                title: 'Account Type',
                dataIndex: 'accountType',
                key: 'accountType',
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'accountNickName',
                render: (status, account) => <StatusTag status={status} account={account} />
            },
            {
                title: 'Restrictions',
                key: 'restrictions',
                render: (account) => <a onClick={() => this.showAccountRestrictions(account)}>View</a>
            },
            {
                // title: 'Action',
                key: 'id',
                dataIndex: 'id',
                align: 'right',
                render: (id, account) => {
                    return account?.locked ? <Flex fullWidth end centerHorizontally>
                        <TextButton
                            // loading={this.state[`${id}LockLoading`]}
                            onClick={(event) => {
                                this.setState({ accountToUnlock: account, showUnlockAccount: true })
                                event.stopPropagation(); // Stop event propagation here as well
                            }}
                            permtype="Override"
                            text='UNLOCK'
                        />
                    </Flex> : <Flex fullWidth end centerHorizontally>
                        <TextButton
                            // loading={this.state[`${id}LockLoading`]}
                            onClick={(event) => {
                                this.setState({ accountToLock: account, showLockAccount: true })
                                event.stopPropagation(); // Stop event propagation here as well
                            }}
                            permtype="Override"
                            text='LOCK'
                        />
                    </Flex>
                },
            }
        ];

        return (
            <>
                <TableView
                    id="accounts-table"
                    className="borderless-table row-pointer"
                    titleText='Accounts'
                    ctaContent={this.props.ctaContent}
                    columns={columns}
                    dataSource={bbAccounts}
                    rowKey='accountNumber'
                    pagination={pagination}
                    onChange={this.handleTableChange}
                    loading={loading}
                />

                <AlertModal
                    imgSrc={Lock}
                    visible={showLockAccount}
                    loading={lockLoading}
                    title='Lock this account?'
                    description={`Are you sure you want to lock ${accountToLock?.nickName}?`}
                    buttonTitle='LOCK'
                    cancelButtonText='CANCEL'
                    onConfirm={() => {
                        this.setState({ lockLoading: true }, () => this.lockAccount(accountToLock))
                    }}
                    onCancel={() => this.setState({ showLockAccount: false, accountToLock: null, lockLoading: false })}
                />

                <AlertModal
                    imgSrc={Unlock}
                    visible={showUnlockAccount}
                    loading={unlockLoading}
                    title='Unlock this account?'
                    description={`Are you sure you want to unlock ${accountToUnlock?.nickName}?`}
                    buttonTitle='UNLOCK'
                    cancelButtonText='CANCEL'
                    onConfirm={() => {
                        this.setState({ unlockLoading: true }, () => this.unlockAccount(accountToUnlock))
                    }}
                    onCancel={() => this.setState({ showUnlockAccount: false, accountToUnlock: null, unlockLoading: false })}
                />
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer,
        bankingStore: state.bankingAppReducer,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(AccountsTable)));